
export enum ServiceOptionType {
  Movilidad = 'movilidad',
  SinMovilidad = 'sin-movilidad',
  Envio = 'envio',
  MontajeDomicilio = 'montaje-domicilio',
}